import React from 'react'
import PropTypes from 'prop-types'

const RepairIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M13.7322 19.5153L17.4141 15.7031L15.2636 13.6262L11.5818 17.4384L13.7322 19.5153Z"
                    fill="#FFC20D"
                />
                <path
                    d="M5.58505 5.5167L3.13894 3.88596L2.18768 4.83722L3.81842 7.41922L5.31326 7.14743L5.58505 5.5167ZM3.13894 8.91406L0.285156 4.70133L3.00305 2.11933L7.07989 4.83722L6.69237 8.45754L3.13894 8.91406Z"
                    fill="#FFC20D"
                />
                <path
                    d="M5.3125 8.24519L6.39966 7.15804L15.9123 16.8065L14.961 17.7578L5.3125 8.24519Z"
                    fill="#FFC20D"
                />
                <path
                    d="M18.5039 26.2598L24.4833 20.1445L35.4907 31.152L29.3755 37.1314L18.5039 26.2598Z"
                    fill="#FFC20D"
                />
                <path
                    d="M36.2695 4.80302C35.9977 4.39534 35.7259 3.98765 35.3182 3.71587C32.4644 0.862079 27.844 0.726184 24.9902 3.57997C23.0877 5.48249 22.4082 8.33628 23.2236 10.9183L23.4954 11.7336L3.92657 31.1666L3.79068 31.3025C3.65478 31.4384 3.51889 31.4384 3.38299 31.7101V31.846C2.97531 32.2537 2.83941 32.9332 2.83941 33.4768C2.83941 34.9716 4.06246 36.1947 5.5573 36.1947C6.10088 36.1947 6.78036 36.0588 7.18804 35.6511L7.45983 35.3793L27.4363 15.5387L28.2517 15.8105C30.8337 16.6259 33.6875 15.9464 35.59 14.0439C36.1336 13.5003 36.6772 12.8208 36.9489 12.1413L29.8824 12.2772L29.7465 5.07481L36.2695 4.80302ZM2.97531 30.0794L21.8646 11.1901C20.9134 8.20039 21.5929 4.80302 23.9031 2.49281C27.3004 -0.904551 32.7362 -0.768656 36.2695 2.62871C37.3566 3.71587 38.0361 4.80302 38.4438 6.16197L30.9696 6.29786L31.1055 10.7824L38.7156 10.6465C38.4438 12.2772 37.6284 13.7721 36.4054 14.9951C34.0952 17.3053 30.6978 17.9848 27.7081 17.0335L8.1393 36.6024C7.45983 37.1459 6.50857 37.4177 5.5573 37.4177C3.2471 37.4177 1.48047 35.5152 1.48047 33.3409C1.48047 32.3896 1.75226 31.5743 2.29584 30.8948L2.43173 30.7589C2.56762 30.4871 2.70352 30.3512 2.97531 30.0794Z"
                    fill="#212327"
                />
                <path
                    d="M5.75348 34.5499C6.504 34.5499 7.11242 33.9415 7.11242 33.191C7.11242 32.4405 6.504 31.832 5.75348 31.832C5.00295 31.832 4.39453 32.4405 4.39453 33.191C4.39453 33.9415 5.00295 34.5499 5.75348 34.5499Z"
                    fill="#8C9297"
                />
                <path
                    d="M22.7176 16.2038C22.9894 16.4756 22.9894 16.8833 22.7176 17.1551L10.4871 29.3856C10.2153 29.6574 9.80766 29.6574 9.53587 29.3856C9.26408 29.1138 9.26408 28.7061 9.53587 28.4344L21.7664 16.2038C22.0382 15.9321 22.4459 15.9321 22.7176 16.2038Z"
                    fill="#8C9297"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.0449219)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

RepairIcon.propTypes = {
    disabled: PropTypes.bool,
}
export default RepairIcon
